import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/account` itself is not a page: it is the first of the three.
 *
 * A redirect rather than a duplicate of the profile screen, so that the one
 * address people have bookmarked — and every `account.goto()` in the suite —
 * still arrives somewhere real.
 */
export const Route = createFileRoute('/account/')({
  beforeLoad: () => {
    throw redirect({ to: '/account/profile' });
  },
});
